import {AdyenPaymentsService} from '../../services/payments'
import {AdyenPaymentsDetailsService} from '../../services/payments-details'
import {executeCallbacks} from '../../utils/executeCallbacks'
import {getCurrencyValueForApi} from '../../utils/parsers'
import {AdyenOrderService} from '../../services/order'
import {setCheckoutBasketRecoveryPending} from '../../checkout-basket-recovery'
import {paidWithGC} from '../../../../api/utils/gcHelpers'

export const baseConfig = ({
    beforeSubmit = [],
    afterSubmit = [],
    beforeAdditionalDetails = [],
    afterAdditionalDetails = [],
    onError = [],
    ...props
}) => {
    return {
        amount: getAmount(props),
        onSubmit: executeCallbacks([...beforeSubmit, onSubmit, ...afterSubmit], props, onError),
        onAdditionalDetails: executeCallbacks(
            [...beforeAdditionalDetails, onAdditionalDetails, ...afterAdditionalDetails],
            props,
            onError
        ),
        onError: executeCallbacks([onErrorHandler], props, onError)
    }
}

export const onSubmit = async (state, component, props) => {
    if (!state.isValid) {
        throw new Error('invalid state')
    }
    try {
        const additionalPaymentData = await props?.getAdditionalPaymentData(
            props?.token,
            props?.site,
            props?.customerId,
            state.data
        )
        const adyenPaymentService = new AdyenPaymentsService(props?.token, props?.site)
        const paymentsResponse = await adyenPaymentService.submitPayment(
            {
                ...state.data,
                additionalPaymentData,
                origin: state.data.origin ? state.data.origin : window.location.origin,
                returnUrl: props?.returnUrl || `${window.location.href}/redirect`
            },
            props.basket?.basketId,
            props?.customerId
        )
        if (paymentsResponse?.error) {
            throw new Error('invalid state')
        }
        return {paymentsResponse: paymentsResponse}
    } catch (e) {
        throw new Error(e.message)
    }
}

export const onAdditionalDetails = async (state, component, props) => {
    const adyenPaymentsDetailsService = new AdyenPaymentsDetailsService(props?.token, props?.site)
    localStorage.removeItem('paymentInProgress')
    const paymentsDetailsResponse = await adyenPaymentsDetailsService.submitPaymentsDetails(
        state.data,
        props.basket?.basketId,
        props?.customerId
    )
    return {paymentsDetailsResponse: paymentsDetailsResponse}
}

export const onErrorHandler = async ({error, props, orderNo, navigate}) => {
    if (error?.name === 'ERROR') {
        throw new Error('refresh')
    }

    const adyenOrderService = new AdyenOrderService(props?.token, props?.site)

    try {
        await adyenOrderService.orderCancel(
            typeof orderNo === 'string'
                ? orderNo
                : localStorage.getItem('orderInProgress') || props?.basket?.c_orderNo, // prioritize the local storage order number that was set after successful /payments call.
            props?.customerId
        )
    } catch (e) {
        console.error('Failed to cancel order:', e)
    }
    localStorage.setItem('orderInProgress', null)
    localStorage.setItem('paymentInProgress', null)
    setCheckoutBasketRecoveryPending()
    if (typeof navigate === 'function') {
        navigate('/checkout')
    } else if (typeof props?.onNavigate === 'function') {
        props.onNavigate('/checkout')
    } else {
        window.location.reload()
    }
}

export const getAmount = ({basket}) => {
    if (!basket) return null

    const paidWithGiftCard = paidWithGC(basket)

    return {
        value: getCurrencyValueForApi(basket.orderTotal - paidWithGiftCard, basket.currency),
        currency: basket.currency
    }
}
